import { ref } from 'vue';
import { getFixedAssetArchiveById } from '@/api/system/user';

export function useBoundUsers() {
  const boundUsers = ref<any[]>([]);
  const loading = ref(false);

  const fetchBoundUsers = async (userId: string) => {
    if (!userId) {
      boundUsers.value = [];
      return;
    }
    loading.value = true;
    try {
      const res = await getFixedAssetArchiveById(userId);
      boundUsers.value = res.data || [];
    } finally {
      loading.value = false;
    }
  };

  return {
    boundUsers,
    loading,
    fetchBoundUsers,
  };
}
